import ApiState from '../../enums/APISTATE';
import Repository from '@/repositories/RepositoryFactory';

const AllocationsRepository = Repository.get('allocations');

export default {
  namespaced: true,
  state: {
    apiState: ApiState.INIT,
    allocations: []
  },
  mutations: {
    setApiState(state, apiState) {
      state.apiState = apiState;
    },
    setAllocations(state, allocationsResponse) {
      const {data} = allocationsResponse;
      state.allocations = data;
      state.apiState = ApiState.LOADED;
    },
  },
  actions: {
    async loadReplacementAllocationsForCurrentWeek({commit}) {
      commit('setApiState', ApiState.LOADING);
      try {
        commit('setAllocations', await AllocationsRepository.getReplacementAllocationsCurrentWeek());
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ApiState.ERROR);
      }
    },
  },
  getters: {
    replacementAllocationsApiState: (state) => state.apiState,
    replacementAllocations: (state) => state.allocations,
  }
}